// extracted by mini-css-extract-plugin
export default {"warning":"LOnDSqngeCE_HEmH3KiQ"};